export { getViewCustomPageRoute, getEditCustomPageRoute } from './routes';
